import { WPTypography } from "..//WPTypography";
import { WarningOutlineIcon } from "../SVGs";

import { combineClassNames } from '../../utils/appUtils';

import "./WPInputHelper.scss";

export const WPInputHelperText = props => {
  const { isError, isWarning, id, text, hide, position = "absolute" } = props;
  if (hide) {
    return null;
  }
  return (
    <div className='wp-input-helperText-wrapper' style={{ position }}>
      {(isError || isWarning) && <WarningOutlineIcon isError={isError} />}
      <WPTypography
        asElement='small'
        id={id + "-helperText"}
        text={text}
        className={combineClassNames("wp-input-helperText fs-10", isError && "error", isWarning && "warning")}
      />
    </div>
  );
};
